import { ConfigProvider } from 'antd';

const getThemeColor = (cssVarName, fallback) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVarName)
    .trim();

  return value || fallback;
};

const CheckboxConfigProvider = ({ children }) => {
  const tertiaryBlue = getThemeColor('--color-tertiary-blue', '#004677');
  const disabledGray = getThemeColor('--color-gray', '#cccccc');
  const white = getThemeColor('--color-white', '#ffffff');
  return (
    <ConfigProvider
      theme={{
        token: {
          controlInteractiveSize: 15, // Adjust the size of the checkbox
        },
        components: {
          Checkbox: {
            colorPrimary: tertiaryBlue, // Checked box background
            colorPrimaryHover: tertiaryBlue, // Hover color
            colorPrimaryBorder: tertiaryBlue, // Border color
            borderRadiusSM: 2, // Circular checkbox (2%)

            // Disabled styles
            colorBgContainerDisabled: disabledGray, // background
            colorBorder: disabledGray, // border (fallback)
            colorTextDisabled: white,
          },
        },
      }}>
      {children}
    </ConfigProvider>
  );
};

export default CheckboxConfigProvider;
